import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Role } from '../types';

interface KpeState {
  role: Role;
  hasKpi: boolean;
  hasDeletedKpi: boolean;
}

const initialState: KpeState = {
  role: 'Р',
  hasKpi: true,
  hasDeletedKpi: true
};

const kpeSlice = createSlice({
  name: 'kpe',
  initialState,
  reducers: {
    setRole(state, action: PayloadAction<Role>) {
      state.role = action.payload;
    },
    setHasKpi(state, action: PayloadAction<boolean>) {
      state.hasKpi = action.payload;
    },
    setHasDeletedKpi(state, action: PayloadAction<boolean>) {
      state.hasDeletedKpi = action.payload;
    }
  }
});

export const { setRole, setHasKpi, setHasDeletedKpi } = kpeSlice.actions;
export const kpeReducer = kpeSlice.reducer;
